export enum SubscriberType {
  CLIENT = 'client',
  EDUCATOR = 'educator',
  GUEST = 'guest',
}
